'use client';

import React from 'react'
import './style.css';
import formatMsg from '../../util/formatMsg';


function page(props) {

    const { payload, renderCancellation, renderReschedule, renderTermsAndConditions, termsVisible, setTermsVisible, tncViewMode, setTncViewMode } = props;

    function showHideTermsAndConditions() {
        setTermsVisible(!termsVisible);
    }

    function renderCancellationPolicy() {
        let content = [];
        if (payload) {
            const { cancellationRules, reschedulingRules } = payload;
            if (renderCancellation) {
                if (cancellationRules.refundDetails) {
                    cancellationRules.refundDetails.map((item) => {
                        content.push(
                            <li className='tnc-fontWeightlight'><span className='tnc-fontWeight600'>{item.percentage}{"% "}{formatMsg("refund")}{": "}</span> {formatMsg("refundPolicy", { frequency: item.type, duration: item.value })}</li>
                        )
                    })
                }
            }
            if (renderReschedule) {
                content.push(
                    <li className='tnc-fontWeightlight'><span className='tnc-fontWeight600'>{formatMsg("rescheduling")}{": "}</span> {formatMsg("reschedulingPolicy", { frequency: formatMsg(reschedulingRules.durationType), duration: reschedulingRules.duration })}</li>
                )
            }
        }
        return <ul className='tnc-participant-container' style={{ paddingLeft: 40 }}> {content} </ul>;
    }
    return (
        <div>
            {
                (renderCancellation || renderReschedule || renderTermsAndConditions)
                    ?
                    <div className='tnc-main-card '>
                        {
                            renderCancellation || renderReschedule
                                ? <>
                                    <div style={{ padding: "16px 0px 8px 16px" }}>
                                        <div className='tnc-package-name'>{formatMsg('cancellationRescPolicy')}</div>
                                    </div>
                                    {renderCancellationPolicy()}
                                </>
                                : null
                        }
                        {
                            renderTermsAndConditions
                                ? <div className='tnc-login-div'
                                    style={{ padding: "16px 16px", cursor: "pointer" }}
                                    onClick={() => {
                                        showHideTermsAndConditions();
                                        setTncViewMode && setTncViewMode(true);
                                    }}>
                                    <div>{formatMsg("view")}{" "}<span className='tnc-text-color'>{formatMsg("label.termsAndConditions")}</span></div>
                                </div>
                                : null
                        }
                    </div>
                    : null
            }
        </div>
    )
}

export default page
